import { type FC } from 'react'

import { type CartIntermediateParams } from './cart-intermediate-params/cartIntermediateParams'
import { CartIntermediateDrawer } from './components/CartIntermediateDrawer'
import { CartIntermediateContextProvider } from './context/CartIntermediateContext'

export const CartIntermediate: FC<CartIntermediateParams> = ({
  drawerId,
  errorType,
  isAddProductToCartSuccessful,
  offer,
  product,
  quantity,
  reccommendedOffer,
  recommendedProduct,
}) => {
  return (
    <CartIntermediateContextProvider
      errorType={errorType}
      isAddProductToCartSuccessful={isAddProductToCartSuccessful}
      offer={offer}
      product={product}
      quantity={quantity}
      recommendedOffer={reccommendedOffer}
      recommendedProduct={recommendedProduct}
    >
      <CartIntermediateDrawer drawerId={drawerId} />
    </CartIntermediateContextProvider>
  )
}
